<h6 mat-dialog-title class="d-flex align-items-center mb-0">
  <mat-icon class="mr-2">assignment</mat-icon>
  {{ 'rooms.popups.reserve.title' | translate }}
</h6>
<div class="popup-subtitle mb-3">
  {{ 'rooms.popups.reserve.subtitle' | translate }}
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
  <form [formGroup]="addEditMakeABookingFormGroup">
    <div class="row mt-4">
      <div class="col-md-12">
        <mat-form-field appearance="fill">
          <mat-label>
            {{ 'rooms.popups.reserve.form.title' | translate }}
          </mat-label>
          <input
            type="text"
            matInput
            formControlName="title"
            [placeholder]="
              translate.instant('rooms.popups.reserve.form.placeholders.title')
            "
            maxlength="50"
            [readonly]="isView"
          />
          <mat-error
            *ngIf="
              addEditMakeABookingFormGroup.get('title').hasError('required') ||
              addEditMakeABookingFormGroup.get('title').hasError('whitespace')
            "
            >{{
              'rooms.popups.reserve.form.required.title' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="fill">
          <mat-label>{{
            'rooms.popups.reserve.form.start-date' | translate
          }}</mat-label>
          <input
            placeholder="{{ 'rooms.popups.reserve.form.from' | translate }}"
            matInput
            formControlName="date"
            [mtxDatetimepicker]="datePicker"
            (click)="datePicker.open()"
            [disabled]="true"
            required
          />
          <mtx-datetimepicker-toggle
            [for]="datePicker"
            matSuffix
          ></mtx-datetimepicker-toggle>
          <mtx-datetimepicker
            #datePicker
            type="date"
            startView="month"
            color="primary"
            mode="portrait"
            [touchUi]="false"
          >
          </mtx-datetimepicker>
          <mat-error
            *ngIf="
              addEditMakeABookingFormGroup.controls.from.hasError('required')
            "
            >{{
              'rooms.popups.reserve.form.required.date' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>{{
            'rooms.popups.reserve.form.from' | translate
          }}</mat-label>
          <input
            placeholder="{{ 'rooms.popups.reserve.form.from' | translate }}"
            matInput
            formControlName="from"
            [mtxDatetimepicker]="fromTimePicker"
            (click)="fromTimePicker.open()"
            [disabled]="isView"
            required
          />
          <mtx-datetimepicker-toggle
            [for]="fromTimePicker"
            matSuffix
          ></mtx-datetimepicker-toggle>
          <mtx-datetimepicker
            #fromTimePicker
            type="time"
            startView="clock"
            color="primary"
            mode="portrait"
            [twelvehour]="true"
            [touchUi]="false"
          >
          </mtx-datetimepicker>
          <mat-error
            *ngIf="
              addEditMakeABookingFormGroup.controls.from.hasError('required')
            "
            >{{
              'rooms.popups.reserve.form.required.from' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>{{
            'rooms.popups.reserve.form.to' | translate
          }}</mat-label>
          <input
            placeholder="{{ 'rooms.popups.reserve.form.to' | translate }}"
            matInput
            formControlName="to"
            [mtxDatetimepicker]="toTimePicker"
            (click)="toTimePicker.open()"
            [disabled]="isView"
            required
          />
          <mtx-datetimepicker-toggle
            [for]="toTimePicker"
            matSuffix
          ></mtx-datetimepicker-toggle>
          <mtx-datetimepicker
            #toTimePicker
            type="time"
            startView="clock"
            color="primary"
            mode="portrait"
            [twelvehour]="true"
            [touchUi]="false"
          >
          </mtx-datetimepicker>
          <mat-error
            *ngIf="
              addEditMakeABookingFormGroup.controls.to.hasError('required')
            "
            >{{
              'rooms.popups.reserve.form.required.to' | translate
            }}</mat-error
          >
          <mat-error
            *ngIf="
              addEditMakeABookingFormGroup.get('to').hasError('invalidToDate')
            "
            >{{
              'rooms.popups.reserve.form.errors.to-validate' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-async-autocomplete
          label="{{
            'rooms.popups.reserve.form.invitees' | translate
          }} ( Maximum Seats: {{ data.seating_capacity }})"
          [filteredOptionsFromParent]="invitees"
          [selectionModes]="SELECTION_MODE.CHIPS"
          [size]="10"
          [total]="invitees.length"
          [isMultiSelectEnabled]="true"
          [selectedForEdit]="selectedUsers"
          [disabled]="isView"
          (selectedItems)="selectUser($event)"
          (asyncInput)="onFilterUsers($event)"
        >
        </el-async-autocomplete>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div *ngIf="!isView">
    <button mat-button mat-dialog-close>
      {{ 'rooms.popups.reserve.form.cancel' | translate }}
    </button>

    <button
      [disabled]="
        !addEditMakeABookingFormGroup.valid || filteredInvitees.length < 1
      "
      mat-flat-button
      mat-dialog-close
      (click)="saveAndClose()"
      color="primary"
    >
      <span *ngIf="!isUpdate">
        {{ 'rooms.popups.reserve.form.reserve' | translate }}
      </span>
      <span *ngIf="isUpdate">
        {{ 'rooms.popups.reserve.form.update' | translate }}
      </span>
    </button>
  </div>
  <div *ngIf="isView">
    <button mat-button mat-dialog-close>
      {{ 'rooms.popups.reserve.form.close' | translate }}
    </button>
  </div>
</mat-dialog-actions>
